if (submitTag && signedIn) {
    Brevo.push(function () {
        Brevo.identify({
            identifiers: {
                email_id: primaryEmail
            },
            attributes: {
                FIRSTNAME: firstName,
                LASTNAME: lastName
            },
        });
    });
}